<div class="dx-fieldset export-row">
    <div class="label-loader-row">
        <div class="dx-field-label custom-label">
            {{ "Ersetzen der 'Technischen Merkmale' im Export" | translate }}

            <dx-switch [(value)]="useAlternativeFeatureSystem"></dx-switch>
        </div>

        <dx-load-indicator
            *ngIf="featureSystemsLoading && useAlternativeFeatureSystem"
            class="inline-loader"
            height="30"
            width="30">
        </dx-load-indicator>
    </div>

    <div class="dx-field custom-stack-column">
  

        <div class="dx-field-value half-width-select">
            <dx-select-box
                *ngIf="useAlternativeFeatureSystem"
                (onValueChanged)="updateCatalogExportSettings()"
                [(value)]="selectedFeatureSystemIdsForExport"
                [dataSource]="featureSystemsInCatalogForExport"
                displayExpr="name"
                valueExpr="id"
                placeholder="{{ 'FeatureSystem wählen' | translate }}"
            >
            </dx-select-box>
        </div>
    </div>
</div>